module.exports = __webpack_public_path__ + "img/logo.1318a2ab.png";